// extracted by mini-css-extract-plugin
module.exports = {"content":"styles-module__content___3A1ay","wrapper":"styles-module__wrapper___2yhFx"};